module.exports = __webpack_public_path__ + "static/media/ponte.f39747f7.png";